var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMatchString = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M24.762 0C25.446 0 26 .554 26 1.238v23.524c0 .684-.554 1.238-1.238 1.238H1.238A1.238 1.238 0 0 1 0 24.762V1.238C0 .554.554 0 1.238 0zM7.5 15a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7zM18.32 5h-2.643v3.047l-2.771-1.035L12 9.557l2.781 1.037-1.935 2.365 2.025 1.74 1.937-2.369L18.311 15l2.292-1.352-1.499-2.66L22 10.461l-.457-2.667-3.223.582V5z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMatchString);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/match-string.a4d998b4138aed8da5387f3bfda5e941.svg";